// A brand's storefront link (?brand=<slug>) locks a seller's menu to that one brand.
//
// Distinct from the ?brands= filter, which the shopper can clear: the server enforces the lock on
// every storefront endpoint, so the client's job is only to forward the slug on each request and
// keep it on the URL as the shopper moves between the listing and product pages.

export const BRAND_LOCK_QUERY_KEY = "brand";

// Mirrors StorefrontBrandLock::KEY on the server.
export const BRAND_LOCK_REQUEST_KEY = "locked_brand";

export function lockedBrandFromQuery(query) {
  const value = query?.[BRAND_LOCK_QUERY_KEY];

  return typeof value === "string" && value ? value : null;
}

/** Request params (GET) or payload fields (POST) that carry the lock. */
export function brandLockParams(slug) {
  return slug ? { [BRAND_LOCK_REQUEST_KEY]: slug } : {};
}

/** URL query that keeps the lock on a navigation. */
export function brandLockQuery(slug) {
  return slug ? { [BRAND_LOCK_QUERY_KEY]: slug } : {};
}
